import StaticMaps from '../StaticMap';

const StaticMapView = (({ itemModel, mapDetails, farmCentreReq, id, setReportButtonVisible }) => {
    const outlineList = itemModel.outlineList;
    const itemList = itemModel.itemList
    const data = { outlineList, itemList, mapDetails, farmCentreReq,id };
    const apiKey = 'HBdKcEDw06L2TRAg1rKBXEhkPjfkSRb4';

    return (
        <StaticMaps apiKey={apiKey} data={data} setReportButtonVisible={setReportButtonVisible}/>
    )
})
export default StaticMapView